import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '@components/buttons/button/button.component';

export interface IConfirmData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-confirm-dialog',
  imports: [MatDialogModule, MatButtonModule, ButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  data: IConfirmData = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    this.dialogRef.addPanelClass('confirm-dialog');
  }

  onNoClick() {
    this.dialogRef.close();
  }

  logout() {
    this.dialogRef.close(true);
  }
}
